import { ComposeFlags } from "../types";

export enum SlotFlag {
  // Characters the document's font can't draw; Send refuses the proposal.
  UNSUPPORTED = "unsupported",
  // Text that didn't fit its box and was cut with "…".
  CUT = "cut"
}

// The flag compose reported for this slot; unsupported wins, since Send refuses it.
export const slotFlag = (
  slotId: string,
  flags: ComposeFlags
): SlotFlag | undefined => {
  if (flags.unsupportedSlotIds.includes(slotId)) return SlotFlag.UNSUPPORTED;
  if (flags.cutSlotIds.includes(slotId)) return SlotFlag.CUT;
  return undefined;
};
